export const changePinRoutes = [
  {
    path: ':walletId/change/pin',
    name: 'change_pin',
    component: () =>
      import('@/views/dashboard/wallet_manage/change-pin/ChangePinMain.vue'),
    meta: {
      PageTitle: 'wallet_manage.change_pin.title',
    },
  },
  {
    path: ':walletId/change/pin/complete',
    name: 'change_pin_complete',
    component: () =>
      import(
        '@/views/dashboard/wallet_manage/change-pin/ChangePinComplete.vue'
      ),
    meta: {
      PageTitle: 'wallet_manage.change_pin.title',
    },
  },
]
